<template>
  <!--begin::Dashboard-->
  <div class="p-5 container" :key="componentKey">
    <div
      class="row mb-5"
      style="padding: 2vh;"
      v-if="listData && listData.length > 0"
    >
      <div
        class="col-12 col-lg-6"
        style="font-style: normal;
                font-weight: 500;
                font-size: 30px;
                line-height: 39px;
                color: #000000;"
      >
      {{ myExam["title"] }}
        <!-- {{ answersList }} -->
      </div>
      <div
        class="col-12 col-lg-6"
        style="display: flex;flex-direction: row;flex-wrap: wrap;align-items: center;justify-content: space-around;"
      >
        <span
          style="font-style: normal;
                font-weight: 500;
                font-size: 20px;
                line-height: 26px;
                color: #000000;"
        >
          คำถามข้อที่
          <span style="color:#F2A17D">{{ page + 1 }}</span> /
          {{ listData ? listData.length : "0" }}</span
        >

        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#kt_modal_answers"
          class="btn btn-info"
        >
          กระดาษคำตอบ
        </button>
        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#kt_modal_calculator_examlearn"
          class="btn btn-secondary"
        >
          <i class="fa fa-calculator"></i> เครื่องคิดเลข
        </button>
        <span
          style="font-weight: 400;
                  font-size: 20px;
                  line-height: 26px;
                  color: #000000;"
        >
          <i class="fa fa-clock"></i> {{ countdown }}</span
        >
      </div>
      <div
        class="col-12 mt-5"
        v-if="listData"
        style="background: #F7F7F7;
                border: 1px solid #D8D8D8;
                border-radius: 15px;
                padding: 20px;"
      >
        <div class="row" style="position: relative;">
          <div class="col-12 col-lg-8 offset-lg-2">
            <!-- <div v-for="(item, index) in captures" :key="index">
            <img v-bind:src="item" style="width: 100%" />
          </div> -->
            <p
              style="font-style: normal;
                  font-weight: 800;
                  font-size: 20px;
                  line-height: 23px;"
            >
              {{ listData[page].textQuestion }}
            </p>
            <img
              v-if="listData[page].imageQuestion"
              :src="imageUrl + listData[page].imageQuestion"
              class="w-100"
              alt=""
            />

            <div class="row" v-if="listData[page].qType == 1 || listData[page].qtype == 1">
              <div
                class="col-12 col-md-6 p-5"
                v-for="(itemA, indexA) in listData[page].questionChoices"
                :key="indexA"
              >
                <div
                  @click="answer[page] = itemA.choiceId; setAnswer(listData[page].id, itemA.choiceId, 1)"
                  style="background: #FFFFFF;
                        border-radius: 10px;
                        height: 100%;
                        padding: 20px;"
                >
                  <img
                    v-if="itemA.imageChoice"
                    :src="imageUrl + itemA.imageChoice"
                    class="w-100"
                    alt=""
                  />
                  <div
                    class="form-check form-check-custom form-check-success form-check-solid my-3"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      :name="'qId' + listData[page].id"
                      :value="itemA.choiceId"
                      :id="'qaId' + itemA.choiceId"
                      v-model="answer[page]"
                    />
                    <label
                      class="form-check-label"
                      :for="'qaId' + itemA.choiceId"
                    >
                      {{ itemA.textChoice }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="my-5">
              <input
                type="text"
                v-model="answer[page]"
                class="form-control"
                @change="setAnswer(listData[page].id, answer[page], 2)"
              />
            </div>
            <div style="display: flex;justify-content: space-between;">
              <button
                type="button"
                @click="previousPage()"
                :disabled="page == 0"
                class="btn btn-exam"
              >
                ก่อนหน้า
              </button>
              <button
                v-if="page == listData.length - 1"
                :disabled="submitButton"
                type="button"
                @click="submit()"
                class="btn btn-exam"
              >
                <span v-if="submitButton" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ submitButton ? 'กำลังส่ง...' : 'ส่งคำตอบ' }}
              </button>
              <button
                v-else
                type="button"
                @click="nextPage()"
                class="btn btn-exam"
              >
                ถัดไป
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- calculator modal -->
  <div class="modal fade" id="kt_modal_calculator_examlearn" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width:320px;">
      <div class="modal-content">
        <div class="modal-header">
          <h2><i class="fa fa-calculator me-2"></i>เครื่องคิดเลข</h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-4">
          <div style="background:#1a1a2e;border-radius:10px;padding:12px 14px;margin-bottom:12px;text-align:right;">
            <div style="color:#888;font-size:13px;min-height:18px;word-break:break-all;">{{ calcExpression || '&nbsp;' }}</div>
            <div style="color:#fff;font-size:32px;font-weight:700;word-break:break-all;">{{ calcDisplay }}</div>
          </div>
          <div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;">
            <button @click="calcClear()" class="calc-btn calc-btn-fn" style="grid-column:span 2;">AC</button>
            <button @click="calcInput('⌫')" class="calc-btn calc-btn-fn">⌫</button>
            <button @click="calcInput('/')" class="calc-btn calc-btn-op">÷</button>

            <button @click="calcInput('7')" class="calc-btn">7</button>
            <button @click="calcInput('8')" class="calc-btn">8</button>
            <button @click="calcInput('9')" class="calc-btn">9</button>
            <button @click="calcInput('*')" class="calc-btn calc-btn-op">×</button>

            <button @click="calcInput('4')" class="calc-btn">4</button>
            <button @click="calcInput('5')" class="calc-btn">5</button>
            <button @click="calcInput('6')" class="calc-btn">6</button>
            <button @click="calcInput('-')" class="calc-btn calc-btn-op">−</button>

            <button @click="calcInput('1')" class="calc-btn">1</button>
            <button @click="calcInput('2')" class="calc-btn">2</button>
            <button @click="calcInput('3')" class="calc-btn">3</button>
            <button @click="calcInput('+')" class="calc-btn calc-btn-op" style="grid-row:span 2;">+</button>

            <button @click="calcInput('0')" class="calc-btn" style="grid-column:span 2;">0</button>
            <button @click="calcInput('.')" class="calc-btn">.</button>

            <button @click="calcEqual()" class="calc-btn calc-btn-eq" style="grid-column:span 4;">=</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="kt_modal_answers"
    tabindex="-1"
    aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Modal header-->
        <div class="modal-header" id="kt_modal_answers_header">
          <!--begin::Modal title-->
          <h2>กระดาษคำตอบ</h2>
          <button
            v-if="videoSkip"
            type="button"
            class="btn btn-sm btn-warning ms-3"
            @click="autoAnswer()"
          >
            ตอบอัตโนมัติ
          </button>
          <!-- {{answer}} -->
          <!--end::Modal title-->
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body py-10 px-lg-17" v-if="listData && listData.length > 0">
          <div
            v-for="(item, index) in listData"
            :key="index"
            :id="item.qaId"
            class="subject "
          >
            <span
              ><button
                class="btn btn-sm w-80px my-2 btn-primary"
                data-bs-dismiss="modal"
                @click="changePage(index)"
              >
                ข้อ {{ index + 1 }}.</button
              >&nbsp;&nbsp;&nbsp;
              <span v-if="listData[index].qType == 1 || listData[index].qtype == 1">
                <span
                  v-for="(item, indexA) in item.questionChoices"
                  :key="indexA"
                  :class="
                    item.choiceId == answer[index]
                      ? 'choice green'
                      : 'choice grey'
                  "
                  >{{ indexA + 1 }}</span
                >
              </span>
              <span v-else class="mx-5">
                {{ answer[index] }}
              </span>
            </span>
          </div>
        </div>
        <div class="modal-body py-10 px-lg-17" v-else>
          <p class="text-center">ไม่พบข้อมูลคำถาม</p>
        </div>
        <div class="modal-footer flex-center"></div>
      </div>
    </div>
  </div>
  <!-- Result Dialog -->
  <el-dialog
    v-model="resultDialogVisible"
    title=""
    width="536px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    align-center
  >
    <div style="padding:8px 0 0;">
      <!-- Title row -->
      <div style="text-align:center;margin-bottom:24px;">
        <span
          style="display:inline-flex;align-items:center;justify-content:center;width:48px;height:48px;border-radius:50%;background:#e6f9f0;margin-bottom:12px;"
        >
          <i class="fa fa-check" style="color:#22c55e;font-size:22px;"></i>
        </span>
        <h2 style="font-size:18px;font-weight:700;margin:0 0 4px;">{{ resultData.title }}</h2>
        <p style="color:#3b4a56;margin:0;font-size:14px;">{{ resultData.subtitle }}</p>
      </div>

      <!-- Info card -->
      <div
        style="background:#f7f7f7;border:1px solid #d8d8d8;border-radius:15px;padding:20px 24px;display:flex;align-items:center;"
      >
        <div style="flex:1;display:flex;flex-direction:column;gap:10px;">
          <div style="display:flex;align-items:center;gap:8px;">
            <i class="fa fa-book-open" style="color:#6b6b6b;font-size:16px;width:20px;text-align:center;"></i>
            <span style="color:#6b6b6b;font-size:13px;">จำนวนข้อสอบ : {{ resultData.totalQuestion }} ข้อ</span>
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <i class="fa fa-file-alt" style="color:#6b6b6b;font-size:16px;width:20px;text-align:center;"></i>
            <span style="color:#6b6b6b;font-size:13px;">คะแนนเต็ม : {{ resultData.totalScore }} คะแนน</span>
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <i class="fa fa-check-circle" style="color:#6b6b6b;font-size:16px;width:20px;text-align:center;"></i>
            <span style="color:#6b6b6b;font-size:13px;">เกณฑ์การผ่าน : {{ resultData.percentPass }}%</span>
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <i class="fa fa-stopwatch" style="color:#6b6b6b;font-size:16px;width:20px;text-align:center;"></i>
            <span style="color:#6b6b6b;font-size:13px;">เวลาในการทำข้อสอบ : {{ resultData.timeSubmit }} นาที</span>
          </div>
        </div>

        <div style="width:1px;align-self:stretch;background:#d8d8d8;margin:0 20px;"></div>

        <div style="flex-shrink:0;display:flex;flex-direction:column;align-items:center;gap:6px;">
          <p style="font-size:16px;font-weight:700;color:#000;margin:0;letter-spacing:-0.3px;">ผลการทดสอบ</p>
          <span
            v-if="resultData.passed"
            style="display:inline-flex;align-items:center;justify-content:center;height:42px;padding:3px 12px;border-radius:6px;background:#e0f1e7;"
          >
            <span style="font-size:20px;font-weight:700;color:#109448;">ผ่าน</span>
          </span>
          <span
            v-else
            style="display:inline-flex;align-items:center;justify-content:center;height:42px;padding:3px 12px;border-radius:6px;background:#ffdee2;"
          >
            <span style="font-size:20px;font-weight:700;color:#d20000;">ไม่ผ่าน</span>
          </span>
        </div>
      </div>

      <!-- Button -->
      <div style="text-align:center;margin-top:24px;">
        <button
          type="button"
          style="min-width:250px;height:58px;font-size:16px;font-weight:500;border-radius:15px;background:#323563;color:#fff;border:none;"
          @click="$router.push({ name: 'exam-history' })"
        >
          กลับไปยังหน้าหลัก
        </button>
      </div>
    </div>
  </el-dialog>
</template>
<script lang="ts">
import { defineComponent, nextTick, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useCookies } from "vue3-cookies";
import jQuery from "jquery";
const $ = jQuery;
const video = ref();
const canvas = ref();
const captures = ref([] as Array<object>);
const listData = ref();
const page = ref(0);
const score = ref(0);
const answer = ref<any[]>([]);
const answersList = ref<Array<{ questionId: any; choiceId: any[]; answerUser: any }>>([]);
import router from "@/router";
const submitButton = ref(false);
const resultDialogVisible = ref(false);
const resultData = ref({
  passed: false,
  title: "",
  subtitle: "",
  totalQuestion: 0,
  totalScore: 0,
  percentPass: 0,
  timeSubmit: "",
  userScore: 0,
  percent: 0,
});
export default defineComponent({
  name: "exam-general-learn",
  components: {},
  data() {
    return {
      checkPermission: 0,
      timeInSecs: 0,
      ticker: 0,
      imageUrl: process.env.VUE_APP_IMG_URL,
      videoSkip: process.env.VUE_APP_VIDEO_SKIP === "true",
      countdown: "",
      calcDisplay: "0",
      calcExpression: "",
      calcHasResult: false,
      dataParams: this.$route.params,
      // eslint-disable-next-line no-undef
      localStream: {
        srcObject: "",
      },
      examRoomProfile: "",
      myExam: [],
      componentKey: 0,
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { cookies } = useCookies();
    const examQuestionKey = "ExamLearnQuestion_" + localStorage.getItem("u_id") + "_" + route.params.id;
    const timerKey = "ExamLearnTimer_" + localStorage.getItem("u_id") + "_" + route.params.id;
    onMounted(() => {
      answersList.value = [];
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      getDataList();
    });
    const getDataList = () => {
      const cached = localStorage.getItem(examQuestionKey);
      if (cached) {
        listData.value = JSON.parse(cached);
        const savedAnswers = localStorage.getItem("examLearnAnswersList_" + route.params.id);
        if (savedAnswers) {
          answersList.value = JSON.parse(savedAnswers);
         console.log(answersList.value);
         
          const restored: any[] = [];
          answersList.value.forEach((item) => {
            if (item.choiceId && item.choiceId.length > 0) {
              const idx = listData.value.findIndex((q) => q.id === item.questionId);
              if (idx !== -1) restored[idx] = item.choiceId[0];
            } else if (item.answerUser) {
              const idx = listData.value.findIndex((q) => q.id === item.questionId);
              if (idx !== -1) restored[idx] = item.answerUser;
            }
          });
          answer.value = restored as any;
        }
        return;
      }
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getExamQuestion?examId=" +
            route.params.id,
          {
            headers: {
              token: localStorage.getItem("id_token")
            },
          }
        )
        .then((response) => {
          listData.value = response.data.data;
          if (listData.value.length == 0) {
            Swal.fire({
              title: "ไม่สามารถทำข้อสอบได้ !",
              text: "ไม่พบข้อมูลคำถามคำตอบกรุณาตรวจสอบข้อมูล",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            }).then((result) => {
              router.go(-1);
            });
          } else {
            localStorage.setItem(examQuestionKey, JSON.stringify(listData.value));
          }
          // console.log(listData.value);
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const previousPage = () => {
      page.value = page.value - 1;
    };
    const nextPage = () => {
      page.value = page.value + 1;
    };
    const changePage = (event) => {
      page.value = event;
    };
    const setDataInArrayObjectById = (array, id, answer, type) => {
      const foundObject = array.find((obj) => obj.questionId === id);
      if (!foundObject) {
        return false;
      }
      if (type == 1) {
        foundObject["choiceId"] = [answer];
      } else {
        foundObject["choiceId"] = [];
        foundObject["answerUser"] = answer;
      }
    };
    const setAnswer = (qId, answer, type) => {
      /* eslint-disable */
      const list: any = {};
      if (answersList.value.length > 0) {
        if (
          setDataInArrayObjectById(answersList.value, qId, answer, type) ==
          false
        ) {
          if (type == 1) {
            list.questionId = qId;
            list.choiceId = [answer];
            list.answerUser = "";
          } else {
            list.questionId = qId;
            list.choiceId = [];
            list.answerUser = answer;
          }
        }
      } else {
        if (type == 1) {
          list.questionId = qId;
          list.choiceId = [answer];
          list.answerUser = "";
        } else {
          list.questionId = qId;
          list.choiceId = [];
          list.answerUser = answer;
        }
      }
      if (list.questionId) {
        answersList.value.push(list);
      }
      console.log("setAnswer:", JSON.parse(JSON.stringify(answersList.value)));
      localStorage.setItem("examLearnAnswersList_" + route.params.id, JSON.stringify(answersList.value));
    };
    return {
      getDataList,
      listData,
      page,
      previousPage,
      nextPage,
      answer,
      changePage,
      setAnswer,
      video,
      canvas,
      captures,
      route,
      answersList,
      setDataInArrayObjectById,
      submitButton,
      examQuestionKey,
      timerKey,
      cookies,
      resultDialogVisible,
      resultData,
    };
  },
  async mounted() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      this.componentKey += 1;
      page.value = 0
    }
    let exam = await axios.get(
      process.env.VUE_APP_API_URL + "/getExam?id=" + this.$route.params.id,
      {
        headers: {
          token: localStorage.getItem("id_token")
        },
      }
    );
    if (exam.data.data.content?.length > 0) {
      this.myExam = exam.data.data.content[0];
      setCurrentPageBreadcrumbs(this.myExam["title"], []);
      if (listData.value && listData.value.length > 0) {
        Swal.fire({
          title: "แบบทดสอบ",
          text:
            "ระบบจะจับเวลาและบันทึกการทำข้อสอบทันที เมื่อคุณกดปุ่มเริ่มทำข้อสอบ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#323563",
          cancelButtonColor: "#d33",
          allowOutsideClick: false,
          confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
          cancelButtonText: "กลับสู่หน้าหลัก",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const savedTimer = localStorage.getItem(this.timerKey);
            const initSecs = savedTimer ? parseInt(savedTimer) : exam.data.data.content[0].limitTime * 60;
            this.startTimer(initSecs);
          } else {
            router.go(-1);
          }
        });
      }
    }
  },
  methods: {
    autoAnswer() {
      if (!listData.value) return;
      listData.value.forEach((question, idx) => {
        if (question.qType == 1 && question.questionChoices) {
          const correct = question.questionChoices.find((c) =>
            c.textChoice && c.textChoice.indexOf("ข้อนี้ถูก") !== -1
          );
          if (correct) {
            answer.value[idx] = correct.choiceId;
            this.setAnswer(question.id, correct.choiceId, 1);
          }
        }
      });
    },
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    startTimer(secs) {
      this.timeInSecs = parseInt(secs);
      this.ticker = window.setInterval(() => {
        this.tick();
      }, 1000);
    },
    tick() {
      var secs = this.timeInSecs;
      if (secs > 0) {
        this.timeInSecs--;
      } else {
        clearInterval(this.ticker);
        Swal.fire({
      title: "หมดเวลาทำข้อสอบแล้ว!",
      text: "ต้องการส่งคำตอบหรือไม่ ?",
      icon: "error",
      buttonsStyling: false,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: "ส่งคำตอบ",
      cancelButtonText: "ยกเลิก",
      customClass: {
        confirmButton: "btn fw-semibold btn-primary btn-lg",
        cancelButton: "btn fw-semibold btn-light-danger btn-sm",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.submit()
      } else {
        this.$router.go(-1);
      }
    });
      }
      var mins = Math.floor(secs / 60);
      secs %= 60;
      var pretty =
        (mins < 10 ? "0" : "") + mins + ":" + (secs < 10 ? "0" : "") + secs;
      this.countdown = pretty;
      localStorage.setItem(this.timerKey, this.timeInSecs + "");
    },
    percentageToDegrees(percentage) {
      return (percentage / 100) * 360;
    },
    async submit() {
      Swal.fire({
        title: "ต้องการส่งคำตอบใช่หรือไม่",
        icon: "warning",
  buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: "ส่งคำตอบ",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn fw-semibold btn-primary btn-lg",
            cancelButton: "btn fw-semibold btn-light-danger btn-sm",
          },
      }).then((result) => {
        if (result.isConfirmed) {
          submitButton.value = true;
          clearInterval(this.ticker);
          clearInterval(this.checkPermission);
          let timeSubmit = this.convertStoMs(
            this.myExam["limitTime"],
            this.countdown
          );
          let examId = this.$route.params.id;
          score.value = 0;
          axios
            .post(
              process.env.VUE_APP_API_URL + "/checkAnswer",
              answersList.value,
              {
                headers: {
                  token: localStorage.getItem("id_token")
                },
              }
            )
            .then((res) => {
              // console.log(this.myExam);
              score.value = res.data.data.score;
              const formData = new FormData();
              formData.append("score", score.value + "");
              formData.append("examId", examId + "");
              axios
                .post(process.env.VUE_APP_API_URL + "/updateScore", formData, {
                  headers: {
                    token: localStorage.getItem("id_token")
                  },
                })
                .then(async (res) => {
                  if (res.data.status == 400) {
                    Swal.fire({
                      title: "แจ้งเตือนข้อผิดพลาด",
                      text: res.data.message,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                      customClass: {
                        confirmButton: "btn fw-semobold btn-light-danger",
                      },
                    });
                  }
                  submitButton.value = false;
                  localStorage.removeItem(this.examQuestionKey);
                  localStorage.removeItem(this.timerKey);
                  localStorage.removeItem("examLearnAnswersList_" + this.$route.params.id);
                  let percent = await this.formatNumber(
                    (score.value / listData.value.length) * 100
                  );

                  const passed = percent >= this.myExam["percentPass"];
                    // title: passed ? "ส่งคำตอบเรียบร้อยแล้ว" : "เสียใจด้วย คุณไม่ผ่านการทดสอบ",
                    // subtitle: passed
                    //   ? "โปรดติดต่อเจ้าหน้าที่ที่ดูแลการสอบ"
                    //   : "โปรดติดต่อเจ้าหน้าที่ เพื่อขอทำการทดสอบอีกครั้งโดยจะต้องทำการจองเพื่อขอสอบผ่านระบบเท่านั้น",
                  resultData.value = {
                    passed,
                    title: "ส่งคำตอบเรียบร้อยแล้ว",
                    subtitle: "",
                    totalQuestion: this.myExam["totalQuestion"],
                    totalScore: this.myExam["totalScore"],
                    percentPass: this.myExam["percentPass"],
                    timeSubmit,
                    userScore: score.value,
                    percent,
                  };
                  resultDialogVisible.value = true;
                })
                .catch((error) => {
                  // console.log(error);
                  Swal.fire({
                    title: "แจ้งเตือนข้อผิดพลาด",
                    text: error.message,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                    customClass: {
                      confirmButton: "btn fw-semobold btn-light-danger",
                    },
                  });
                });
            })
            .catch((error) => {
              submitButton.value = false;
              // console.log(error);
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: error.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }else{
          submitButton.value = false
        }
      });
    },
    calcClear() {
      this.calcDisplay = "0";
      this.calcExpression = "";
      this.calcHasResult = false;
    },
    calcInput(val: string) {
      const ops = ["+", "-", "*", "/"];
      if (val === "⌫") {
        if (this.calcHasResult) {
          this.calcDisplay = "0";
          this.calcExpression = "";
          this.calcHasResult = false;
          return;
        }
        this.calcDisplay = this.calcDisplay.length > 1 ? this.calcDisplay.slice(0, -1) : "0";
        return;
      }
      if (ops.includes(val)) {
        this.calcExpression = (this.calcHasResult ? this.calcDisplay : this.calcExpression + this.calcDisplay) + val;
        this.calcDisplay = "0";
        this.calcHasResult = false;
        return;
      }
      if (this.calcHasResult) {
        this.calcDisplay = val === "." ? "0." : val;
        this.calcExpression = "";
        this.calcHasResult = false;
        return;
      }
      if (val === "." && this.calcDisplay.includes(".")) return;
      this.calcDisplay = this.calcDisplay === "0" && val !== "." ? val : this.calcDisplay + val;
    },
    calcEqual() {
      try {
        const expr = this.calcExpression + this.calcDisplay;
        const result = Function('"use strict"; return (' + expr + ')')();
        this.calcDisplay = String(parseFloat(result.toFixed(10)));
        this.calcExpression = expr + "=";
        this.calcHasResult = true;
      } catch {
        this.calcDisplay = "Error";
        this.calcExpression = "";
        this.calcHasResult = true;
      }
    },
    formatNumber(score) {
      return parseInt(score);
    },
    convertStoMs(limit, countdown) {
      if (!countdown || !countdown.includes(":") || !limit) return "00 : 00";
      const parts = countdown.split(":");
      const remainSecs = parseInt(parts[0]) * 60 + parseInt(parts[1]);
      const usedSecs = parseInt(limit) * 60 - remainSecs;
      if (isNaN(usedSecs) || usedSecs < 0) return "00 : 00";
      let minutes: any = Math.floor(usedSecs / 60);
      let extraSeconds: any = usedSecs % 60;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      extraSeconds = extraSeconds < 10 ? "0" + extraSeconds : extraSeconds;
      return minutes + " : " + extraSeconds;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    beforeUnmount() {
      submitButton.value = false
      localStorage.setItem("reloaded", "1");
      clearInterval(this.ticker);
    },
  },
});
</script>
<style>
span.green {
  background: #5ea226;
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  -webkit-border-radius: 0.8em;
  color: #ffffff;
  display: inline-block;
  font-weight: bold;
  line-height: 1.6em;
  margin-left: 35px;
  text-align: center;
  width: 1.6em;
}
span.grey {
  background: #cccccc;
  border-radius: 0.8em;
  -moz-border-radius: 0.8em;
  -webkit-border-radius: 0.8em;
  color: #fff;
  display: inline-block;
  font-weight: bold;
  line-height: 1.6em;
  margin-left: 35px;
  text-align: center;
  width: 1.6em;
}
.btn-app {
  background: #da595a;
  color: #ffffff;
  border-radius: 100px;
}
.btn-app2 {
  background: #323563;
  color: #ffffff;
  border-radius: 100px;
}
.btn-exam {
  color: #109448;
  background: #ffffff;
  border: 1px solid #109448 !important;
  width: 160px;
  border-radius: 10px;
}
.btn-exam:hover {
  color: #ffffff;
  background: #109448;
  border-radius: 10px;
}
.btn-exam:disabled {
  background: #e5e5e5;
  color: #979797;
  border: 1px solid #d8d8d8 !important;
  border-radius: 10px;
}
.btn-register {
  background: #f2a17d;
  color: #ffffff;
  width: 70%;
  border-radius: 21px;
}
.calc-btn {
  padding: 14px 0;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  background: #2a2a4a;
  color: #fff;
  transition: background 0.15s;
}
.calc-btn:hover { background: #3a3a6a; }
.calc-btn-fn { background: #3d3d5c; color: #f2a17d; }
.calc-btn-fn:hover { background: #4d4d6c; }
.calc-btn-op { background: #f2a17d; color: #fff; }
.calc-btn-op:hover { background: #e08c5c; }
.calc-btn-eq { background: #323563; color: #fff; padding: 12px 0; font-size: 20px; }
.calc-btn-eq:hover { background: #434794; }
</style>
